export default "__VITE_ASSET__DVFWmkIO__"